import { DataTypeConfig } from "../../../../types";

export const networksConfig: DataTypeConfig = {
  tabs: ["networkType", "operationalStatus", "networkOperator", "backupStatus"],
  searchableColumns: [
    "Network Name",
    "Facility ID",
    "Network Type",
    "Operational Status",
    "Network Operator",
    "Backup Status",
    "Description",
  ],
  filterColumns: [
    { column: "Network Type", type: "dropdown", label: "Network Type" },
    {
      column: "Operational Status",
      type: "dropdown",
      label: "Operational Status",
    },
    { column: "Backup Status", type: "dropdown", label: "Backup Status" },
    { column: "Design Capacity", type: "range", label: "Design Capacity" },
  ],
  tableColumns: [
    { key: "networkName", header: "Network Name", type: "custom" },
    { key: "facilityId", header: "Facility ID", type: "custom" },
    { key: "networkType", header: "Network Type", type: "badge" },
    { key: "operationalStatus", header: "Operational Status", type: "badge" },
    { key: "networkOperator", header: "Network Operator", type: "badge" },
    { key: "backupStatus", header: "Backup Status", type: "badge" },
    { key: "description", header: "Description", type: "custom" },
    { key: "designCapacity", header: "Design Capacity", type: "custom" },
  ],
  mandatoryFields: [
    "Network Name",
    "Facility ID",
    "Network Type",
    "Operational Status",
    "Network Operator",
    "Backup Status",
    "Design Capacity",
    "Description",
  ],
};

export const networksTabDisplayNames: Record<string, string> = {
  networkType: "Network Type",
  operationalStatus: "Operational Status",
  networkOperator: "Network Operator",
  backupStatus: "Backup Status",
};

export const networksTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "networkType":
      return [
        { value: "distribution", label: "Distribution" },
        { value: "transmission", label: "Transmission" },
        { value: "collection", label: "Collection" },
        { value: "supply", label: "Supply" },
      ];
    case "operationalStatus":
      return [
        { value: "operational", label: "Operational" },
        { value: "under_maintenance", label: "Under Maintenance" },
        { value: "non_operational", label: "Non-Operational" },
        { value: "planned", label: "Planned" },
      ];
    case "networkOperator":
      return [
        { value: "john_smith", label: "John Smith" },
        { value: "sarah_johnson", label: "Sarah Johnson" },
        { value: "operations_team_a", label: "Operations Team A" },
        { value: "operations_team_b", label: "Operations Team B" },
      ];
    case "backupStatus":
      return [
        { value: "available", label: "Available" },
        { value: "not_available", label: "Not Available" },
        { value: "partial", label: "Partial" },
      ];
    default:
      return [];
  }
};
